import { render } from "./OrganizationalCommunicationsSection.vue?vue&type=template&id=7c677bc7"
import script from "./OrganizationalCommunicationsSection.vue?vue&type=script&lang=js"
export * from "./OrganizationalCommunicationsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__